/**
 * Grille — autant de colonnes que la largeur en tient (lot « surfaces », 01-11-2026) : des
 * tuiles de chiffres, des cartes de comptes, des vignettes. `min` est la largeur sous laquelle
 * une tuile ne descend pas ; sur un téléphone, une colonne. `colonnes` fixe le nombre au lieu
 * de le laisser couler (une colonne sur un téléphone quand même).
 *
 *   <Grille min={220}>{tuiles}</Grille>
 *   <Grille colonnes={2} ecart={16}>…</Grille>
 */
import type { CSSProperties, ReactNode } from "react";

import { cn } from "./utils";
import "./surfaces.css";

export interface GrilleProps {
  children: ReactNode;
  /** La largeur minimale d'une tuile, en px. Défaut 220. */
  min?: number;
  /** Un nombre de colonnes fixe (une seule sur un téléphone). */
  colonnes?: number;
  /** L'écart, en px. Défaut 12. */
  ecart?: number;
  className?: string;
}

export function Grille({ children, min = 220, colonnes, ecart = 12, className }: GrilleProps) {
  const style = { "--sf-min": `${min}px`, "--sf-gap": `${ecart}px`, "--sf-colonnes": colonnes } as CSSProperties;
  return (
    <div className={cn("sf-grille", className)} style={style} data-colonnes={colonnes !== undefined ? colonnes : undefined}>
      {children}
    </div>
  );
}
